import type { ModalProps } from "@mantine/core"
import { modals } from "@mantine/modals"
import { useRef } from "react"

let MODAL_NEXT_ID = 0

export function useModal(baseProps: Partial<ModalProps>) {
  const modalIdRef = useRef(`${MODAL_NEXT_ID++}`)
  const modalId = modalIdRef.current

  return {
    id: modalId,
    open: (props?: Partial<ModalProps>) => {
      modals.close(modalId)
      return modals.open({ size: "auto", ...baseProps, ...props, modalId })
    },
    close: () => modals.close(modalId),
  }
}
